import * as types from './actionTypes'
// @ts-ignore
import { createRequestActions } from 'helpers'

export const favoriteActivities = {
  get: createRequestActions({
    request: types.FAVORITE_ACTIVITIES.GET.REQUEST,
    success: types.FAVORITE_ACTIVITIES.GET.SUCCESS,
    fail: types.FAVORITE_ACTIVITIES.GET.FAIL,
  }),
  post: createRequestActions({
    request: types.FAVORITE_ACTIVITIES.POST.REQUEST,
    success: types.FAVORITE_ACTIVITIES.POST.SUCCESS,
    fail: types.FAVORITE_ACTIVITIES.POST.FAIL,
  }),
  delete: createRequestActions({
    request: types.FAVORITE_ACTIVITIES.DELETE.REQUEST,
    success: types.FAVORITE_ACTIVITIES.DELETE.SUCCESS,
    fail: types.FAVORITE_ACTIVITIES.DELETE.FAIL,
  }),
}

export const selectPage = (page: any) => ({
  type: types.FAVORITE_ACTIVITIES_SELECT_PAGE,
  payload: {
    page,
  },
})

export const setFilter = (by: any, value: any) => ({
  type: types.FAVORITE_ACTIVITIES_SET_FILTER,
  payload: {
    by,
    value,
  },
})
